/**
 * @memberOf loavies.models.chat
 * @constructor
 */
export class ChatModel {
  /**
   * @param {string} id
   * @param {loavies.models.chat.TalkJsChatModel} talkJsChat
   * @param {loavies.models.transaction.TransactionModel} transaction
   */
  constructor({
    id,
    talkJsChat,
    transaction,
  }) {

    /** @type {string} */
    this.id = id

    /** @type {loavies.models.chat.TalkJsChatModel} */
    this.talkJsChat = talkJsChat

    /** @type {loavies.models.transaction.TransactionModel} */
    this.transaction = transaction
  }
}
